import { AnalyticsSkuViewed } from '@ria-client/segment/Analytics/AnalyticsSkuViewed';
import {
  EntityPlacementCtaTypeEnum,
  EntityTypeEnum,
  MarketplaceStatusEnum,
} from '@ria-client/supergraph/marketplace/enums';
import { CtaButton } from '@ria-client/tw-shared-ui';
import { getSmbMarketplaceEntity } from './smb-marketplace-entity';

const SECTION_NAME = 'illustration_card_list';

export interface MarketplaceEntityCTAProps {
  marketplaceEntityId: string;
  text?: string;
}

export async function MarketplaceEntityCTA({
  marketplaceEntityId,
  text,
}: MarketplaceEntityCTAProps) {
  const marketplaceEntity = await getSmbMarketplaceEntity(marketplaceEntityId);

  if (!marketplaceEntity || marketplaceEntity.status === MarketplaceStatusEnum.Inactive) {
    return null;
  }

  if (!marketplaceEntity.cta?.link) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-2" data-testid="smb-marketplace-entity-cta">
      <AnalyticsSkuViewed
        impressionPosition={0}
        impressionSection={SECTION_NAME}
        level={
          marketplaceEntity.entityType
            ? EntityTypeEnum[marketplaceEntity.entityType]
            : EntityTypeEnum.offers
        }
        monetizable={marketplaceEntity.monetizable}
        name={marketplaceEntity.name}
        offerId={marketplaceEntity.id}
        productType={marketplaceEntity.productType}
        source="marketplace"
      >
        <CtaButton
          analyticsPayload={{
            index: 0,
            monetizable: marketplaceEntity.monetizable,
            offerId: marketplaceEntity.id,
          }}
          className="w-full md:w-[189px]"
          cta={{
            ...marketplaceEntity.cta,
            text: text ?? marketplaceEntity.cta.text,
            type: EntityPlacementCtaTypeEnum.ApplyNowButton,
          }}
        />
      </AnalyticsSkuViewed>
      {marketplaceEntity.cta.subtext ? (
        <span className="typography-text-small text-muted-foreground">
          {marketplaceEntity.cta.subtext}
        </span>
      ) : null}
    </div>
  );
}
